import React, {Component} from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import {connect} from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import {Link} from 'react-router-dom';
import {
    SelectPatientSample,
    SelectAllRiders,
    SelectAllPatients,
    SelectAllHCF,
    SelectReceivedPatientSamplesList
} from '../OfflineDb/IndexDbTranscSP'
import {SyncConfig} from '../OfflineDb/ConfigDataSync'
import DropDown from '../CommonControlls/DropdownRendrer'


const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        ShowLoader: (Isloading) => {
            dispatch({type: "UpdateLoader", payload: Isloading})
        },
    }
}

class SamplesToReceive_List extends Component {

    constructor(props) {
        super(props);
        this.state = {

            // Table
            data: [],
            page: 1,
            sizePerPage: 15,
            TotalRecord: 0,
            loading: false,

            sortField: "id",
            idsortOrder: "desc",

            permissions: [],

            CollectSampleData: [],
            SampleId: 0,

            Patientslist: [],
            Riderslist: [],
            HCFlist: [],

            MTBlist: [{id: 1, name: "Invalid"}, {id: 2, name: "Detected"}, {id: 3, name: "Not Detected"}, {
                id: 4,
                name: "Error"
            }],
            MTBId: 0,

            RRlist: [{id: 1, name: "Invalid"}, {id: 2, name: "Detected"}, {id: 3, name: "Not Detected"}, {
                id: 4,
                name: "Indeterminate"
            }],
            RRId: 0,

        };
    }

    changeRating = (newRating, name) => {
        this.setState({
            rating: newRating
        });
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState({[fieldId]: value})
    }

    render() {

        const CellMenu = (cell, row) => {
            return (
                <div>
                    {row.deliveryStatus === 5 ? "" :
                        <button onClick={() => {
                            this.ShowSampleStatusModal(row.id)
                        }} data-toggle="tooltip" title="Enter Status" class="btn TableRow_btn">
                            <i class="fa fa-file-text-o" aria-hidden="true"></i>
                        </button>
                    }
                </div>
            )
        }


        const CollectCellMenu = (cell, row) => {
            return (
                <div>
                    <button onClick={() => {
                        this.RemovePatientSampleFromList(row.id)
                    }} data-toggle="tooltip" title="Enter Status" class="btn TableRow_btn">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                </div>
            )
        }

        function avatarformatter(cell, row) {
            return (
                <span>
                    {row.PatientName}<br/>
                    <span>{row.PatientContact}</span>
                </span>
            );
        }

        const columns = [
            {
                dataField: 'id',
                text: 'Sample Id',
                sort: true,
            },
            {
                dataField: '',
                text: 'Patient',
                formatter: (cell, row) => {
                    return avatarformatter(cell, row)
                },
                // sort: true,
            }
            , {
                dataField: 'afbResult',
                text: 'AFB Result',
                // sort: true,
                formatter: (cell, row) => {
                    return <span>{cell === 1 ? "Negative" : cell === 2 ? "Positive" : ""}</span>
                },
                csvFormatter: (cell, row) => (cell === 1 ? "Negative" : cell === 2 ? "Positive" : ""),
            }

            , {
                dataField: 'afbResultType',
                text: 'AFB Grading',
                // sort: true,
                formatter: (cell, row) => {
                    return <span>{cell === 1 ? "Scanty" : cell === 2 ? "1+" : cell === 3 ? "2+" : cell === 4 ? "3+" : ""}</span>
                },
                csvFormatter: (cell, row) => (cell === 1 ? "Scanty" : cell === 2 ? "1+" : cell === 3 ? "2+" : cell === 4 ? "3+" : ""),
            }
            , {
                dataField: 'mtbResult',
                text: 'MTB Result',
                // sort: true,
                formatter: (cell, row) => {
                    return <span>{cell === 1 ? "Invalid" : cell === 2 ? "Detected" : cell === 3 ? "Not Detected" : cell === 4 ? "Error" : ""}</span>
                },
                csvFormatter: (cell, row) => (cell === 1 ? "Invalid" : cell === 2 ? "Detected" : cell === 3 ? "Not Detected" : cell === 4 ? "Error" : ""),
            }
            , {
                dataField: 'rrResult',
                text: 'RR Result',
                // sort: true,
                formatter: (cell, row) => {
                    return <span>{cell === 1 ? "Invalid" : cell === 2 ? "Detected" : cell === 3 ? "Not Detected" : cell === 4 ? "Indeterminate" : ""}</span>
                },
                csvFormatter: (cell, row) => (cell === 1 ? "Invalid" : cell === 2 ? "Detected" : cell === 3 ? "Not Detected" : cell === 4 ? "Indeterminate" : ""),
            }
            // ,{
            //     dataField: 'PatientName',
            //     text: 'Patient Name',
            //     sort: true,
            // }
            // ,{
            //     dataField: 'PatientContact',
            //     text: 'Patient Contact',
            //     sort: true,
            // }
            // ,{
            //     dataField: 'HCFName',
            //     text: 'HCF',
            //     sort: true,
            // },{
            //     dataField: 'RiderName',
            //     text: 'Rider',
            //     sort: true,
            // }
            // ,{
            //     dataField: 'rider',
            //     text: 'Result Status',
            //     sort: true,
            // }
            , {
                dataField: '',
                text: '',
                headerStyle: (colum, colIndex) => {
                    return {width: '120px'}
                },
                formatter: (cell, row) => {
                    return CellMenu(cell, row)
                },
                csvExport: false
            }
        ];

        const CollectSampleColumns = [
            {
                dataField: 'id',
                text: 'Sample Id',
            },
            {
                dataField: 'PatientName',
                text: 'Patient Name',
            },
            {
                dataField: 'HCFName',
                text: 'HCF',
            }, {
                dataField: 'RiderName',
                text: 'Rider',
            }, {
                dataField: '',
                text: '',
                headerStyle: (colum, colIndex) => {
                    return {width: '120px'}
                },
                formatter: (cell, row) => {
                    return CollectCellMenu(cell, row)
                },
                csvExport: false
            }
        ];


        return (

            <div>
                <MainLayout/>
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle="Patient Samples"
                             isShowAddBtn={this.state.permissions.includes('patientsamples-add')}/>

                    {/* -------------------Update Status-------- */}
                    <button id="UpdateStatusModal_btn" style={{display: "none"}} type="button" class="btn btn-primary"
                            data-toggle="modal" data-target="#UpdateStatus_Modal">Large modal
                    </button>
                    <div class="modal fade" id="UpdateStatus_Modal" tabindex="-1" role="dialog"
                         aria-labelledby="addappTitle" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document" style={{maxWidth: "500px"}}>
                            <div class="modal-content">

                                <div class="modal-header">
                                    <div class="ModalTopClose_btn"><span style={{cursor: "pointer"}}
                                                                         id="UpdateStatusModal_Closebtn"
                                                                         data-dismiss="modal"
                                                                         aria-hidden="true">x</span></div>
                                    <h5 class="modal-title" id="exampleModalLongTitle"
                                        style={{fontSize: "17px", fontWeight: "700"}}>Enter Sample Result</h5>
                                    {/* <i class="fa fa-times-circle appointmentdetailcross" id="UpdateStatusModal_Closebtn" data-dismiss="modal" aria-hidden="true"></i> */}
                                </div>

                                <div class="modal-body">
                                    <form onSubmit={this.SaveResultStatus} novalidate>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">MTB</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="MTBId"
                                                options={this.state.MTBlist}
                                                val={this.state.MTBId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={false}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">RR</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="RRId"
                                                options={this.state.RRlist}
                                                val={this.state.RRId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={false}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">Description</label>
                                            <textarea class="form-control" id="Status_Description" rows="3"></textarea>
                                        </div>

                                        <div style={{float: "right", marginRight: "15px", marginTop: "35px"}}>
                                            <button type="button" class="btn btn_style3" data-dismiss="modal"
                                                    aria-hidden="true">CANCEL
                                            </button>
                                            <button type="submit" class="btn btn_style1">SAVE</button>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="content">

                        <div class="card">
                            <div class="card-body">

                                <div class="Table_Search row">

                                    <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <input autocomplete="off" type="text" class="form-control Search_InputField"
                                               id="SearchId" placeholder="Sample Id"/>
                                    </div>

                                    <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <input autocomplete="off" type="text" class="form-control Search_InputField"
                                               id="SearchName" placeholder="Patient Name"/>
                                    </div>

                                    <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <input autocomplete="off" type="text" class="form-control Search_InputField"
                                               id="SearchContact" placeholder="Patient Contact"/>
                                    </div>

                                    <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <button onClick={() => {
                                            this.PopulateTable()
                                        }} id="FormSearchBtn" class="btn btn_style1">Search
                                        </button>
                                    </div>

                                </div>

                                <Table
                                    keyField="id"
                                    data={this.state.data}
                                    page={this.state.page}
                                    sizePerPage={this.state.sizePerPage}
                                    exportAllowed={this.state.permissions.includes('patientsamples-export')}
                                    totalSize={this.state.TotalRecord}
                                    onTableChange={this.handleTableChange}
                                    changeSizePerPage={(size) => {
                                        setTimeout(() => {
                                            this.setState({
                                                exportLoading: true
                                            })
                                            this.ExportData(size)
                                        }, 100)
                                    }}
                                    isPagination={true}
                                    columns={columns}
                                    loading={this.state.loading}
                                    RefreshTable={this.PopulateTable}
                                />

                            </div>
                        </div>


                        {/* <div class="card" style={{marginBottom:"20px",background:"none",boxShadow:"none"}}>
                <div class="card-body row" style={{padding:"0px"}}>               
                    <div class="widget-tabs-list">

                        <ul class="Cases-nav nav nav-tabs">
                            <li><a data-toggle="tab" href="#ReceivedSamples_tab" class="active show">Received Samples</a></li>
                            <li><a data-toggle="tab" href="#SamplesDispatched_tab">Receive Samples</a></li>
                        </ul>

                        <div class="tab-content tab-custom-st">
                                
                            <div id="ReceivedSamples_tab" class="tab-pane fade in active show">
                                <div class="tab-ctn">
                                   
                                </div>                             
                            </div>
                                
                            <div id="SamplesDispatched_tab" class="tab-pane fade ui-tabs-panel">
                                <div class="tab-ctn">
                                    <div class="card">
                                        <div class="card-body">

                                            <div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12" style={{marginBottom:"40px"}}>
                                                <input autocomplete="off" type="text" class="form-control Search_InputField" id="SampleToReceive_Id" placeholder="Start typing or scanning..."/>
                                            </div>
                        
                                            <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <Table 
                                                    keyField="id" 
                                                    data={ this.state.CollectSampleData } 
                                                    isPagination={false}
                                                    columns = {CollectSampleColumns}
                                                    loading={false}
                                                />
                                            </div>
                                        
                                            <div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginTop:"30px"}}>
                                                <button type="button" onClick={this.CollectSamples} id="Form_SaveBtn" class="btn btn_style1">Save</button>
                                            </div>

                                        </div>
                                    </div>
                        
                                </div>
                            </div>
                        
                        </div>

                    </div>             
                </div>
            </div> 
         */}


                    </div>

                </div>
            </div>

        )
    }


    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }

    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_SamplesToReceive")

        $("#SampleToReceive_Id").keyup((event) => {
            if (event.keyCode === 13) {
                this.ValidateSample()
            }
        });

        this.GetPageConfigData(() => {
            this.PopulateTable()
        })
        $(".Search_InputField").on('keypress', (e) => {
            if (e.which === 13) {
                this.PopulateTable()
            }
        });
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.SelectAll_RolesPermissions, {
            pageSize: 15,
            pageNumber: 1
        }, (resp) => {
            const modifiedPermissions = resp.data.filter(p => p.permissioN_GROUP === 'Patient Samples' && p.permissioN_ALLOWED).map(d => d.permissioN_NAME)
            this.setState({permissions: modifiedPermissions})
        })
    }

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({Isloading: true})
        var d1 = $.Deferred();
        var d2 = $.Deferred();
        var d3 = $.Deferred();
        this.SelectPatients(() => {
            d1.resolve()
        })
        this.SelectRiders(() => {
            d2.resolve()
        })
        this.SelectHCF(() => {
            d3.resolve()
        })
        $.when(d1, d2, d3).done(() => {
            this.props.ShowLoader({Isloading: false})
            CallBack()
        });
    }
    SelectPatients = (Callback) => {
        SelectAllPatients((data) => {
            var ProcessedPatient = Common.ProcessDataInArray(data, "id")
            this.setState({
                Patientslist: ProcessedPatient
            })
            Callback()
        }, (error) => {
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    SelectRiders = (Callback) => {
        SelectAllRiders((data) => {
            var ProcessedRider = Common.ProcessDataInArray(data, "id")
            this.setState({
                Riderslist: ProcessedRider
            })
            Callback()
        }, (error) => {
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    SelectHCF = (Callback) => {
        SelectAllHCF((data) => {
            var ProcessedHCF = Common.ProcessDataInArray(data, "id")
            this.setState({
                HCFlist: ProcessedHCF
            })
            Callback()
        }, (error) => {
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    handleTableChange = (type, {page, sizePerPage, filters, sortField, sortOrder, cellEdit}) => {
        if (type === "sort") {
            let tempFieldorderLabel = sortField + "sortOrder"
            let tempFieldorder = this.state[tempFieldorderLabel] === "" ? sortOrder : this.state[tempFieldorderLabel] === "asc" ? "desc" : "asc"
            this.setState({
                sortField,
                [tempFieldorderLabel]: tempFieldorder
            }, () => {
                this.PopulateTable()
            })
            return
            // let result = this.state.data
            // // Handle column sort
            // if (sortOrder === 'asc') {
            //     result = result.sort((a, b) => {
            //     if (a[sortField] > b[sortField]) {
            //         return 1;
            //     } else if (b[sortField] > a[sortField]) {
            //         return -1;
            //     }
            //     return 0;
            //     });
            // } else {
            //     result = result.sort((a, b) => {
            //     if (a[sortField] > b[sortField]) {
            //         return -1;
            //     } else if (b[sortField] > a[sortField]) {
            //         return 1;
            //     }
            //     return 0;
            //     });
            // }
            // return
        }
        this.setState({
            page,
            sizePerPage
        }, () => {
            this.PopulateTable()
        })
    }
    PopulateTable = () => {
        $("#FormSearchBtn").prop('disabled', true);
        this.setState({loading: true})
        SelectReceivedPatientSamplesList({
            Id: $("#SearchId").val(),
            name: $("#SearchName").val(),
            contact: $("#SearchContact").val(),
            xpertSiteId: this.props.UserAuthentication.UserInfo?.xpertSiteId
        }, {pageSize: this.state.sizePerPage, pageNumber: this.state.page}, (data) => {
            $("#FormSearchBtn").prop('disabled', false);
            if (data.length > 0) {
                var ProcessedPatient = Common.ProcessDataInArray(this.state.Patientslist, "id")

                for (var i in data.data) {
                    data.data[i].PatientName = data.data[i].patientId == null || data.data[i].patientId === "" ? "" : ProcessedPatient[data.data[i].patientId].name
                    data.data[i].PatientName = data.data[i].patientId == null || data.data[i].patientId === "" ? "" : ProcessedPatient[data.data[i].patientId].name
                    data.data[i].PatientContact = data.data[i].patientId == null || data.data[i].patientId === "" ? "" : ProcessedPatient[data.data[i].patientId].contact

                }
                this.setState({
                    data: data.data,
                    TotalRecord: data.data.totalRecord,
                    loading: false
                })
            } else {
                this.setState({
                    data: [],
                    TotalRecord: 0,
                    loading: false
                })
            }
        }, (error) => {
            // $("#FormSearchBtn").prop('disabled', false);
            // this.setState({loading: false})
            // this.props.ShowAlert({Type: 0, Msg: error})
            // setTimeout(function () {
            //     $("#Alertmsgbtn").click()
            // }, 50);
            $("#FormSearchBtn").prop('disabled', false);
            this.setState({ loading: false })
            this.props.ShowAlert({ Type: 0, Msg: "" })
            setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
        })

    }
    ShowSampleStatusModal = (id) => {
        this.setState({
            SampleId: id,
            MTBId: 0,
            RRId: 0,
        })
        $("#Status_Description").val("")
        $("#UpdateStatusModal_btn").click()
    }
    SaveResultStatus = (e) => {
        e.preventDefault()
        if (this.state.MTBId === 0) {
            this.props.ShowAlert({Type: 0, Msg: "MTB result is required"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        if (this.state.RRId === 0) {
            this.props.ShowAlert({Type: 0, Msg: "RR result is required"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        this.props.ShowLoader({Isloading: true})
        var Parameters = {
            id: this.state.SampleId,
            mtbResult: this.state.MTBId,
            rrResult: this.state.RRId,
            resultDescription: $("#Status_Description").val(),
        }
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.Save_SampleResult, Parameters, (resp) => {
                if (resp.status) {
                    SyncConfig(() => {
                            this.setState({
                                SampleId: 0,
                                MTBId: 0,
                                RRId: 0,
                            })
                            $("#Status_Description").val("")
                            $("#UpdateStatusModal_Closebtn").click()
                            this.PopulateTable()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 1, Msg: "Saved successfully"})
                            setTimeout(() => {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        },
                        () => {
                            this.setState({
                                SampleId: 0,
                                MTBId: 0,
                                RRId: 0,
                            })
                            $("#Status_Description").val("")
                            $("#UpdateStatusModal_Closebtn").click()
                            this.PopulateTable()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 0, Msg: "Error in sync, please reload the page"})
                            setTimeout(function () {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        })
                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })
    }


    ValidateSample = () => {
        if ($("#SampleToReceive_Id").val() === "") {
            this.props.ShowAlert({Type: 0, Msg: "No record found"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        SelectPatientSample(Common.TryParseInt($("#SampleToReceive_Id").val()), (resp) => {
            if (resp === undefined || resp.isSubmitted === false || resp.deliveryStatus === Common.DeliveryStatus.Delivered || resp.deliveryStatus === Common.DeliveryStatus.Tested) {
                $("#SampleToReceive_Id").val("")
                this.props.ShowAlert({
                    Type: 0,
                    Msg: resp === undefined ? "No record found" : resp.deliveryStatus === Common.DeliveryStatus.Delivered || resp.deliveryStatus === Common.DeliveryStatus.Tested ? "Sample alredy received" : "No record found"
                })
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
                return
            }
            this.LoadPatientSampleInList(resp)
        }, () => {
        })
    }
    LoadPatientSampleInList = (data) => {
        let Arr = this.state.CollectSampleData
        for (var i in Arr) {
            if (Arr[i].id === data.id) {
                $("#SampleToReceive_Id").val("")
                return
            }
        }
        data.PatientName = data.patientId == null || data.patientId === "" ? "" : this.state.Patientslist[data.patientId].name
        data.RiderName = data.riderId == null || data.riderId === "" ? "" : this.state.Riderslist[data.riderId].name
        data.HCFName = data.hfcId == null || data.hfcId === "" ? "" : this.state.HCFlist[data.hfcId].name
        Arr.unshift(data)
        this.setState({
            CollectSampleData: Arr
        })
        $("#SampleToReceive_Id").val("")
    }
    RemovePatientSampleFromList = (id) => {
        var Array = this.state.CollectSampleData.filter(function (item, index) {
            return item.id !== id;
        });
        this.setState({
            CollectSampleData: Array,
        })
    }
    CollectSamples = () => {

        if (this.state.CollectSampleData.length === 0) {
            this.props.ShowAlert({Type: 0, Msg: "Please add atleast one sample to save"})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            return
        }
        let SampleIds = Common.convertToCommaString(this.state.CollectSampleData, "id")
        this.props.ShowLoader({Isloading: true})
        var Parameters = {
            SampleIds: SampleIds,
            receiveDatetime: Common.ConvertToUtcDateTime(new Date())
        }
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.Receive_PatientSample, Parameters, (resp) => {
                if (resp.status) {
                    SyncConfig(() => {
                            this.setState({rating: 0, CollectSampleData: []})
                            $("#Rider_Comments").val("")
                            $("#StarRatingModal_btn").click()
                            this.PopulateTable()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 1, Msg: "Saved successfully"})
                            setTimeout(() => {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        },
                        () => {
                            this.setState({rating: 0, CollectSampleData: []})
                            $("#Rider_Comments").val("")
                            $("#StarRatingModal_btn").click()
                            this.PopulateTable()
                            this.props.ShowLoader({Isloading: false})
                            this.props.ShowAlert({Type: 0, Msg: "Error in sync, please reload the page"})
                            setTimeout(function () {
                                $("#Alertmsgbtn").click()
                            }, 50);
                        })
                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })

    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SamplesToReceive_List);
